import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import AutoMarkerTargetTemplatesList from "@dyl/pages/AutoMarkerTargetTemplates/list/AutomarkerTargetTemplatesList";
import Config from "@dyl/pages/AutoMarkerTargetTemplates/list/Config";
import { useLevels } from "@dyl/systems/LevelsManager";

export default function AutomarkerTargetTemplatesList() {
    const [tab, setTab] = useState('amtt');
    const { globalLevel } = useLevels();

    if (globalLevel.label === 'A1') {
        return (<>
            <Tabs
                value={tab}
                onChange={(event, value) => setTab(value)}
                indicatorColor='primary'
            >
                <Tab value='amtt' label='Target Templates'/>
                <Tab value='config' label='Configuration'/>
            </Tabs>

            {tab === 'amtt'
                ? <AutoMarkerTargetTemplatesList/>
                : <Config/>
            }
        </>)
    } else {
        return <AutoMarkerTargetTemplatesList/>
    }
}

